import { Navigate, useParams } from "react-router";

/**
 * `/lobby/:code` — kept as a redirect, not a screen.
 *
 * It rendered a `Placeholder` from phase 3 to phase 10, and the lobby it
 * promised now lives at `/party/:code`, before the game starts. That is not
 * tidying: **the seat is a device cookie set by joining**, and joining happens
 * on the party route. A separate lobby URL would be a page that can show you a
 * roster and cannot give you a place in it.
 *
 * The redirect stays because the path was in handoff notes and may be in
 * somebody's history. `replace` so the back button does not bounce.
 */
export function LobbyPage() {
  const { code } = useParams();
  return <Navigate to={`/party/${code ?? ""}`} replace />;
}
